import React, { useState } from 'react';
import SocialIcons from '../00-shared/SocialIcons';
import { contactEmail } from '../00-shared/constants';

interface ContactFormSectionProps {
    highlightColor: {
        primary: string;
        hover: string;
        gradient: {
            from: string;
            to: string;
            fromLight: string;
            toGray: string;
        };
    };
}

const ContactFormSection: React.FC<ContactFormSectionProps> = ({ highlightColor }) => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        projectType: '',
        message: ''
    });

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        alert('Thank you! Your message has been sent.');
        setFormData({ name: '', email: '', projectType: '', message: '' });
    };

    return (
        <section className="pt-32 py-20 px-4 sm:px-6 lg:px-8 bg-black relative notebook-grid overflow-hidden">
            <div className="max-w-4xl mx-auto relative z-10">
                <div className="pb-12 border-b border-neutral-800">
                    <h1 className="text-4xl md:text-5xl font-bold text-white mb-8 text-center observe-fade opacity-0">Contact Us</h1>
                    <p className="text-gray-300 text-center observe-fade opacity-0">
                        We are here to answer any question you may have. Email us at {contactEmail}
                    </p>
                </div>            
                {/* <form onSubmit={handleSubmit} className="space-y-6 observe-fade opacity-0 mt-12">
                    <div>
                        <label htmlFor="name" className="block text-white mb-2">Name</label>
                        <input
                            type="text"
                            id="name"
                            required
                            value={formData.name}
                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                            className="w-full px-4 py-3 bg-neutral-900 border border-neutral-800 text-white placeholder-gray-400 focus:outline-none focus:ring-2"
                            style={{
                                '--focus-ring-color': highlightColor.primary
                            } as React.CSSProperties & { '--focus-ring-color': string }}
                            onFocus={(e) => {
                                e.currentTarget.style.boxShadow = `0 0 0 2px ${highlightColor.primary}`;
                            }}
                            onBlur={(e) => {
                                e.currentTarget.style.boxShadow = '';
                            }}
                        />
                    </div>

                    <div>
                        <label htmlFor="email" className="block text-white mb-2">Email</label>
                        <input
                            type="email"
                            id="email"
                            required
                            value={formData.email}
                            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                            className="w-full px-4 py-3 bg-neutral-900 border border-neutral-800 text-white placeholder-gray-400 focus:outline-none focus:ring-2"
                            style={{
                                '--focus-ring-color': highlightColor.primary
                            } as React.CSSProperties & { '--focus-ring-color': string }}
                            onFocus={(e) => {
                                e.currentTarget.style.boxShadow = `0 0 0 2px ${highlightColor.primary}`;
                            }}
                            onBlur={(e) => {
                                e.currentTarget.style.boxShadow = '';
                            }}
                        />
                    </div>

                    <div>
                        <label htmlFor="projectType" className="block text-white mb-2">Your Team</label>
                        <select
                            id="projectType"
                            required
                            value={formData.projectType}
                            onChange={(e) => setFormData({ ...formData, projectType: e.target.value })}
                            className="w-full px-4 py-3 bg-neutral-900 border border-neutral-800 text-white focus:outline-none focus:ring-2"
                            style={{
                                '--focus-ring-color': highlightColor.primary
                            } as React.CSSProperties & { '--focus-ring-color': string }}
                            onFocus={(e) => {
                                e.currentTarget.style.boxShadow = `0 0 0 2px ${highlightColor.primary}`;
                            }}
                            onBlur={(e) => {
                                e.currentTarget.style.boxShadow = '';
                            }}
                        >
                            <option value="">Select a Team</option>
                            <option value="Ncaa">NCAA</option>
                            <option value="Gym">Gym</option>
                            <option value="Clinic">Clinic</option>
                            <option value="Personal">Personal</option>
                            <option value="Other">Other</option>
                        </select>
                    </div>

                    <div>
                        <label htmlFor="message" className="block text-white mb-2">Your message (optional)</label>
                        <textarea
                            id="message"
                            rows={6}
                            value={formData.message}
                            onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                            className="w-full px-4 py-3 bg-neutral-900 border border-neutral-800 text-white placeholder-gray-400 focus:outline-none focus:ring-2 resize-none"
                            style={{
                                '--focus-ring-color': highlightColor.primary
                            } as React.CSSProperties & { '--focus-ring-color': string }}
                            onFocus={(e) => {
                                e.currentTarget.style.boxShadow = `0 0 0 2px ${highlightColor.primary}`;
                            }}
                            onBlur={(e) => {
                                e.currentTarget.style.boxShadow = '';
                            }}
                        />
                    </div>

                    <button
                        type="submit"
                        className="w-full px-8 py-4 text-lg text-white transition-colors font-medium"
                        style={{ backgroundColor: highlightColor.primary }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = highlightColor.hover;
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = highlightColor.primary;
                        }}
                    >
                        Send Message
                    </button>
                </form> */}
                <div className="mt-16 flex justify-center">
                    <SocialIcons />
                </div>
            </div>
        </section>
    );
};

export default ContactFormSection;

